import { hexStyleForResolution } from "./style-config.js";

export {
  clampCountShadingThreshold as clampQuantityThresholdForHandle,
  closestCountShadingHandle as closestQuantityThresholdHandle,
  COUNT_SHADING_FILL_STYLE as HEX_QUANTITY_FILL_STYLE,
  COUNT_SHADING_MINIMUM_MAXIMUM as HEX_QUANTITY_MINIMUM_MAXIMUM,
  countForPointerPosition as quantityCountForPointerPosition,
  countShadingFillColorExpression as quantityFillColorExpression,
  countShadingSliderBounds as quantityThresholdSliderBounds,
  DEFAULT_COUNT_SHADING_THRESHOLDS as DEFAULT_HEX_QUANTITY_THRESHOLDS,
  nextCountShadingThresholds as nextQuantityThresholds,
  normalizeCountShadingThresholds as normalizeQuantityThresholds,
  sickReportCountCategory,
  sickReportCountColor,
  validateCountShadingThresholds as validateQuantityThresholds,
} from "../count-shading.js";

export function quantityDotRadiusExpression(resolution) {
  return interpolateQuantityExpression(hexStyleForResolution(resolution).quantityDotRadiusStops);
}

function interpolateQuantityExpression(stops) {
  return ["interpolate", ["linear"], ["get", "totalCount"], ...stops.flat()];
}
